import axios from "axios"



export const addMobiguestlinkLogs = (payload) => {
    const headers = {
        headers: {
            accesskey: "Ep93HIHKC6ZLV6duzxDGD9t7",
        },
    };

    return axios.post("https://us-central1-connexionsservices-e7c1c.cloudfunctions.net/mobiguestapi/api/v1/logs/mobiguestlink", payload, headers);
};
